module.exports = __webpack_public_path__ + "img/wallpaper-10.c21c8067.jpg";